@let _details = address?.details;

@if (title) {
  <sd-title [titleLevel]="titleLevel" customClass="c__title is-body-m is-semi-bold" data-testid="title">
    {{ title }}
  </sd-title>
}

@if (_details) {
  <div class="c__card c__card-details">
    <div class="c__card-details-wrapper">
      <p class="c__card-details-title is-caption is-bold">{{ _details.title }}</p>
      <p class="c__card-details-info is-caption">{{ _details.info }}</p>
    </div>
    <p class="c__card-details-caption is-overline">{{ _details.caption }}</p>
  </div>
}

<div sdIsCollapsible
  class="c__card"
  (isOpenChange)="toggle()"
  [(isOpen)]="isCardOpened"
  [collapsiblePanel]="hide?.nativeElement"
  [action]="action?.nativeElement"
  data-testid="card"
>
  @if (isSelectable) {
    <sd-form
      checkbox
      [(checked)]="selected"
      (checkedChange)="updateCheckboxStatus()"
      [labelTitle]="checkboxLabel"
      [labelHidden]="true"
      [isRadio]="true"
      nameField="addressSelect"
      [required]="true"
      data-testid="form"
    />
  }

  <div class="c__content-wrapper" (click)="toggle()" data-testid="content">
    @if (address?.addressName) {
      <sd-title [titleLevel]="titleLevel + 1" customClass="c__address-name brand--h5" data-testid="name">
        {{ address?.addressName }}
      </sd-title>
    }

    <p class="is-caption" data-testid="infos">
      <strong>{{ address?.firstname }} {{ address?.lastname }}</strong>
      <span>{{ address?.address }}</span>
      <span>{{ address?.postalCode }} {{ address?.city }}</span>
      <span ngClass="is-uppercase">{{ address?.country }}</span>
    </p>

    @if (address?.openingHours) {
      <button sd-button-icon
        #action
        type="button"
        [attr.aria-describedby]="'titleCard' + idCard"
        [attr.aria-controls]="isCardOpened"
        [buttonIconTitle]="'storelocator.openingHour' | translate"
        [titleHidden]="false"
        class="c__toggle-hours"
        [icon]="isCardOpened? 'icon-arrow-up' : 'icon-arrow-down'"
        [size]="iconSize.small"
        [attr.aria-expanded]="isCardOpened"
      ></button>
      <ul class="c__store-opening" #hide sd-list-block>
        @for (opening of address?.openingHours; track opening) {
          <li class="is-caption">
            <span>{{ opening.weekDay || '-' }}</span>
            @if (opening.closed) {
              <span class="is-bold" [attr.data-color]="'error-base'">
                {{ 'storelocator.store.close' | translate }}
              </span>
            } @else if (opening.availability?.length) {
              <!-- TODO-EL: à retester car on tapait directement dans opening.openingTime?.formattedHour -->
              @for (hours of opening.availability; track hours) {
                <span class="is-bold">
                  {{ hours.openingTime?.formattedHour || '  ' }} - {{ hours.closingTime?.formattedHour || '  ' }}
                </span>
              }
            }
          </li>
        }
      </ul>
    }
  </div>

  @if (!readOnly && !inactive) {
    <div class="c__actions">
      @if (!address?.pickup && !address?.repair) {
        @if (!isSelectable && showMainAddress) {
          <button sd-button
            class="is-reset"
            type="button"
            [isIcon]="isSelectable"
            [isSmall]="true"
            [icon]="address?.isMain ? 'icon-heart-filled' : 'icon-heart'"
            [iconPos]="positionEnum.left"
            (click)="setMainAddress()"
            data-testid="set-main"
          >
            <span class="{{isSelectable ? 'is-visually-hidden' : ''}} {{address?.isMain ? 'is-active' : 'is-unactive'}}">
              {{ (address?.isMain ?'checkout.address.actions.isMain' : 'checkout.address.actions.notMain') | translate }}
            </span>
          </button>
        }
        <button sd-button
          class="is-reset"
          type="button"
          [isIcon]="isSelectable"
          [isSmall]="true"
          icon="icon-edit"
          [iconPos]="positionEnum.left"
          (click)="editAddress()"
          data-testid="edit"
        >
          <span [class]="isSelectable ? 'is-visually-hidden' : ''">
            {{ 'checkout.address.actions.edit' | translate }}
          </span>
        </button>
        @if (!isSelectable && canChooseOther) {
          <button sd-button
            class="is-reset"
            type="button"
            [isSmall]="true"
            icon="icon-switch"
            [iconPos]="positionEnum.left"
            (click)="otherAddress()"
            data-testid="other"
          >
            <span>{{ 'checkout.address.actions.chooseOther' | translate }}</span>
          </button>
        }
      } @else {
        <button sd-button
          class="is-reset"
          type="button"
          [isSmall]="true"
          icon="icon-edit"
          [iconPos]="positionEnum.left"
          (click)="otherAddress()"
        >
          <span>{{ pickupRepairChooseAction | translate }}</span>
        </button>
      }
    </div>
  }
</div>
